export default __webpack_public_path__ + "static/media/smartdharma.6658f567.webp";